
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Bookinnovaforoustation() {



    const cardData =
    {
        keyword: 'Book Innova for Outstation Pune',
        heading: 'Meghana Cab : Book Innova for Outstation Pune',
        headingDescription: 'Meghana Cab offers Book Innova for Outstation out of Pune, providing a premium, spacious, and dependable travel experience for long-distance trips. Whether you are heading to hill stations, pilgrimage sites, tourist hotspots, or nearby cities, our Innova vehicles deliver comfort, style, and convenience for families, friends, or corporate groups.',


        top: 'Top Places to Visit in Pune Outstation with Meghana Cab',

"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Approximately 120 km from Pune, Mahabaleshwar is a lush hill station nestled in the Sahyadri ranges. Known for its cool climate, strawberry farms, and colonial-era viewpoints like Arthur’s Seat and Wilson Point, it offers a refreshing escape. Boating at Venna Lake, visiting Mapro Garden, exploring historic temples, and trekking to waterfalls like Lingmala make it ideal for couples, families, and nature lovers alike. The misty atmosphere during monsoon and vibrant hues in winter add charm to every visit."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 65–70 km from Pune, Lonavala and Khandala are twin hill stations celebrated for their green valleys, ancient caves, and mist-laden ambiance. Bhushi Dam, Tiger’s Leap, Karla and Bhaja Caves, and Rajmachi Fort are among the must-visit attractions. During the monsoon, countless waterfalls enhance the landscape. Adventure parks, luxury resorts, and chikki stalls make it a complete weekend getaway for trekking groups, couples, and families alike."
  },
  {
    "title": "Lavasa",
    "description": "Located 60 km from Pune, Lavasa is India’s first planned hill city inspired by Italian towns. Built beside the serene Warasgaon Lake, Lavasa offers scenic promenades, lakeside cafés, cycling trails, and water sports. The colorful architecture and peaceful environment make it a romantic and rejuvenating retreat. It’s also a favorite for pre-wedding shoots, family outings, and wellness vacations."
  },
  {
    "title": "Alibaug",
    "description": "About 145 km from Pune, Alibaug is a coastal gem known for its clean beaches, historic sea forts, and delicious seafood. Kolaba Fort, Alibaug Beach, Nagaon Beach, and Kashid Beach are major attractions. Water sports like jet skiing and parasailing are available at several spots. Alibaug also offers charming homestays and beachside resorts, making it a perfect blend of relaxation and adventure, especially for weekend getaways and group trips."
  },
  {
    "title": "Shirdi",
    "description": "Around 190 km from Pune, Shirdi is a renowned spiritual town dedicated to Sai Baba. Pilgrims visit the Shri Sai Baba Samadhi Mandir, Dwarkamai, Chavadi, and Gurusthan for spiritual solace. The town has excellent facilities for devotees including free meals, lodging, and organized darshan queues. Ideal for a one or two-day spiritual journey, Shirdi is one of Maharashtra’s most visited pilgrimage destinations."
  },
  {
    "title": "Nashik",
    "description": "Located about 210 km from Pune, Nashik is a multifaceted destination blending pilgrimage and wine tourism. The city is home to Trimbakeshwar Jyotirlinga and Kalaram Temple, and also hosts the Kumbh Mela. On the leisure side, vineyards like Sula, York, and Soma offer wine-tasting sessions and vineyard tours. This unique mix makes Nashik ideal for both spiritual travelers and weekend explorers looking for scenic vineyards and riverfront views."
  },
  {
    "title": "Bhimashankar",
    "description": "Situated 110 km from Pune, Bhimashankar is revered as one of the 12 Jyotirlingas of Lord Shiva. Surrounded by dense forests of the Western Ghats, it is also part of the Bhimashankar Wildlife Sanctuary—home to rare species like the Giant Indian Squirrel (Shekru). The trek through the misty Sahyadris and the serene temple make this a top choice for both pilgrims and trekkers seeking peace in nature."
  },
  {
    "title": "Kolhapur",
    "description": "Approximately 235 km from Pune, Kolhapur is a culturally rich city known for the Mahalaxmi Temple, spicy cuisine, Kolhapuri chappals, and Maratha royal heritage. Tourists can visit Rankala Lake, the New Palace Museum, Jyotiba Temple, and Panhala Fort. With vibrant traditions and warm hospitality, Kolhapur is a fulfilling outstation option for history buffs, pilgrims, and food lovers alike."
  },
  {
    "title": "Goa",
    "description": "Roughly 450 km from Pune, Goa is India’s ultimate beach destination offering a mix of relaxation, adventure, and nightlife. North Goa is known for party beaches like Baga, Anjuna, and Calangute, while South Goa offers quieter retreats like Palolem and Agonda. From Portuguese churches and spice plantations to casinos and seafood shacks, Goa has something for every traveler. Ideal for extended holidays, friends’ trips, and honeymoon escapes."
  },
  {
    "title": "Ajanta & Ellora Caves (Aurangabad)",
    "description": "Located 250–270 km from Pune, these UNESCO World Heritage Sites near Aurangabad are among India’s greatest artistic and spiritual treasures. Ajanta features ancient Buddhist cave paintings dating back to the 2nd century BCE, while Ellora showcases a blend of Hindu, Buddhist, and Jain rock-cut temples including the awe-inspiring Kailasa Temple. A cultural and archaeological haven, it’s best visited over a 2-day trip."
  }
],

"services": [
  {
    "name": "Book Outstation Innova Pune",
    "description": "Plan your next long-distance journey with ease by booking our Outstation Innova service in Pune. Whether it’s a weekend getaway or a multi-day tour, enjoy spacious seating, reliable vehicles, and professional chauffeurs dedicated to making your trip comfortable and safe."
  },
  {
    "name": "Rent Innova for Outstation Pune",
    "description": "Rent a premium Innova for your outstation travels from Pune. Our fleet is well-maintained and equipped with modern amenities, ensuring a smooth and comfortable ride on highways and rural roads alike, perfect for families, friends, and corporate travelers."
  },
  {
    "name": "Outstation Innova Taxi Pune",
    "description": "Travel hassle-free with our outstation Innova taxi services from Pune. Our drivers are experienced in long-distance routes, prioritizing safety and punctuality while offering a luxurious travel experience that combines space, comfort, and convenience."
  },
  {
    "name": "Affordable Outstation Innova Pune",
    "description": "Get the best value for your outstation trips with our affordable Innova rentals from Pune. We provide transparent pricing and flexible packages designed to suit your budget without compromising on comfort or service quality."
  },
  {
    "name": "Chauffeur Driven Outstation Innova Pune",
    "description": "Relax and enjoy the journey with our chauffeur-driven outstation Innova taxis in Pune. Our professional drivers ensure timely pickups, smooth driving, and courteous service, making your long-distance travel safe and stress-free."
  },
  {
    "name": "Online Booking Outstation Innova Pune",
    "description": "Conveniently book your outstation Innova taxi online from Pune. Our easy-to-use platform offers instant booking confirmation, secure payments, and customizable trip options, ensuring a hassle-free planning experience for your travels."
  },
  {
    "name": "Family Outstation Innova Pune",
    "description": "Make family trips memorable and comfortable with our spacious outstation Innova taxis from Pune. With ample seating, luggage space, and air conditioning, our vehicles are perfect for group travel, sightseeing, and weekend vacations."
  },
  {
    "name": "Corporate Outstation Innova Pune",
    "description": "Enhance your corporate travel experience with our premium outstation Innova taxi services in Pune. Ideal for business trips, client visits, and executive tours, our services combine professionalism, punctuality, and comfort tailored to your corporate needs."
  }
],
"tableData": [
  ["Book Outstation Innova Pune", "Rent Innova for Outstation Pune"],
  ["Outstation Innova Taxi Pune", "Affordable Outstation Innova Pune"],
  ["Chauffeur Driven Outstation Innova Pune", "Online Booking Outstation Innova Pune"],
  ["Family Outstation Innova Pune", "Corporate Outstation Innova Pune"]
],



"whychoose": [
    {
        "WhyChooseheading": "Book Innova for Outstation Travel from Pune",
        "WhyChoosedescription": "Experience smooth and stress-free travel with our Innova and Innova Crysta outstation cab services from Pune. Whether you're heading to a nearby hill station, religious site, or a multi-day tour, enjoy unmatched comfort, safety, and convenience with our spacious cabs."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable for Long Journeys",
        "WhyChoosedescription": "The Innova is ideal for long-distance trips with its roomy interiors, soft reclining seats, and excellent suspension. Carry ample luggage and travel comfortably with up to 6–7 passengers—perfect for family holidays, group tours, or weekend getaways."
    },
    {
        "WhyChooseheading": "Professional Drivers with Route Expertise",
        "WhyChoosedescription": "Our drivers are trained for long routes and familiar with major outstation destinations like Mumbai, Lonavala, Mahabaleshwar, Shirdi, Goa, and more. They ensure a safe, timely, and comfortable journey with courteous service throughout."
    },
    {
        "WhyChooseheading": "Clean, Well-Maintained, and Sanitized Cabs",
        "WhyChoosedescription": "Each vehicle undergoes thorough cleaning and sanitization before every trip. We prioritize hygiene, comfort, and reliability with routine maintenance checks to ensure your safety on the road."
    },
    {
        "WhyChooseheading": "Flexible Travel Plans and Custom Itineraries",
        "WhyChoosedescription": "Book one-way, round-trip, or multi-day travel from Pune to your chosen outstation destination. We offer itinerary customization—choose pickup/drop points, stopovers, and travel times that work best for your plan."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our rental prices are clear and all-inclusive—covering tolls, fuel, taxes, and driver allowances. We ensure honest billing with no last-minute surprises, providing full value for your money."
    },
    {
        "WhyChooseheading": "Perfect for Leisure, Family Trips, and Business Travel",
        "WhyChoosedescription": "Innova rentals are perfect for pilgrimages, sightseeing tours, destination weddings, and business visits. Travel in style and comfort, no matter the purpose of your journey."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Book your outstation Innova cab from Pune online anytime or through our helpline. Our support team is available 24/7 to help with itinerary planning, booking changes, or special travel needs."
    }
]


















    }

const faqData = [
    {
        question: "How can I book an Innova for outstation trips from Pune?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or through our website for easy and quick outstation booking."
    },
    {
        question: "Which destinations are covered in outstation trips from Pune?",
        answer: "We cover popular outstation destinations including Mumbai, Hyderabad, Goa, Mahabaleshwar, Shirdi, Aurangabad, and more."
    },
    {
        question: "Is the Innova suitable for long-distance travel?",
        answer: "Yes, the Innova offers comfort, ample space, and smooth rides ideal for long-distance journeys."
    },
    {
        question: "Can I book a one-way or round-trip outstation Innova cab?",
        answer: "Yes, we offer both one-way and round-trip options for your convenience."
    },
    {
        question: "How many passengers can the Innova accommodate for outstation trips?",
        answer: "The Innova can comfortably seat 6 to 7 passengers along with luggage."
    },
    {
        question: "Are the vehicles sanitized before every trip?",
        answer: "Yes, all our vehicles are thoroughly cleaned and sanitized before each journey to ensure passenger safety."
    },
    {
        question: "Do your drivers have experience with outstation routes?",
        answer: "Absolutely. Our drivers are skilled and knowledgeable about outstation routes for a safe and smooth trip."
    },
    {
        question: "What is included in the outstation rental fare?",
        answer: "The fare includes fuel, tolls, and driver charges. Additional waiting or parking fees may apply."
    },
    {
        question: "Is the outstation Innova cab service available 24/7?",
        answer: "Yes, we provide round-the-clock service for outstation bookings from Pune."
    },
    {
        question: "What payment methods are accepted for booking?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Sanjay Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova for our Pune to Goa trip. The car was spacious, driver courteous, and service top-notch.”',
    },
    {
        name: 'Ms. Neha Deshpande',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent experience booking an Innova for outstation travel from Pune. Highly recommend Meghana Cab!”',
    },
];


















































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const outstationInnovaPuneSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Book Innova for Outstation Trips from Pune",
  "description": "Affordable and chauffeur-driven Innova taxi service for outstation trips from Pune. Perfect for family travel, corporate journeys, and easy online booking.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/book-innova-outstation-pune"
  }
};







    return (
        <div>

<Helmet>
  <title>Book Innova for Outstation Trips from Pune | Chauffeur Driven Taxi</title>
  <meta
    name="description"
    content="Book affordable chauffeur-driven Innova taxis for outstation trips from Pune. Family and corporate travel with easy online booking."
  />
  <meta
    name="keywords"
    content="Book Outstation Innova Pune, Rent Innova for Outstation Pune, Outstation Innova Taxi Pune, Affordable Outstation Innova Pune, Chauffeur Driven Outstation Innova Pune, Online Booking Outstation Innova Pune, Family Outstation Innova Pune, Corporate Outstation Innova Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(outstationInnovaPuneSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/36.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bookinnovaforoustation;